var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 78,
    viewBox: "0 0 79 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15602_55804)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.5 39C78.5 17.4609 61.0391 0 39.5 0C17.9609 0 0.5 17.4609 0.5 39C0.5 60.5391 17.9609 78 39.5 78C61.0391 78 78.5 60.5391 78.5 39Z",
    fill: "#FAEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9204 23.3443C38.0829 21.3865 40.9171 21.3865 42.0796 23.3443L55.8094 46.4682C56.9967 48.468 55.5555 50.9998 53.2298 50.9998H25.7702C23.4445 50.9998 22.0033 48.468 23.1906 46.4682L36.9204 23.3443Z",
    fill: "#FE5D7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9219 31.9082H38.0775L38.3331 41.0744H40.6726L40.9219 31.9082ZM39.5029 45.1653C40.3211 45.1653 41.0306 44.4814 41.037 43.6312C41.0306 42.7939 40.3211 42.1099 39.5029 42.1099C38.6591 42.1099 37.9624 42.7939 37.9688 43.6312C37.9624 44.4814 38.6591 45.1653 39.5029 45.1653Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15602_55804"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 78,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.60d651996a6c643b4f6b3bb8439a0702.svg";
export { ForwardRef as ReactComponent };